// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "js/" + chunkId + "-legacy." + {"264":"2aae9b8a","604":"f264aaad"}[chunkId] + ".js"; };